import { lazy } from 'react';

import timeout from '#client/utils/timeout';

const IntroPage = lazy(() => timeout(import('#client/pages/EducationStudio/components/CustomPage/IntroPage')));
const GenericPage = lazy(() => timeout(import('#client/pages/EducationStudio/components/CustomPage/GenericPage')));
const LetsFindYourIkigai = lazy(() => timeout(import('#client/pages/EducationStudio/components/CustomPage/Peaks/letsFindYourIkigai')));
const WhatYouLove = lazy(() => timeout(import('#client/pages/EducationStudio/components/CustomPage/Peaks/whatYouLove')));
const WhatTheWorldNeeds = lazy(() => timeout(import('#client/pages/EducationStudio/components/CustomPage/Peaks/whatTheWorldNeeds')));
const WhatYouCanGetPaidFor = lazy(() => timeout(import('#client/pages/EducationStudio/components/CustomPage/Peaks/whatYouCanGetPaidFor')));
const WhatYoureGoodAt = lazy(() => timeout(import('#client/pages/EducationStudio/components/CustomPage/Peaks/whatYoureGoodAt')));
const YourMission = lazy(() => timeout(import('#client/pages/EducationStudio/components/CustomPage/Peaks/yourMission')));
const YourVocation = lazy(() => timeout(import('#client/pages/EducationStudio/components/CustomPage/Peaks/yourVocation')));
const YourProfession = lazy(() => timeout(import('#client/pages/EducationStudio/components/CustomPage/Peaks/yourProfession')));
const YourPassion = lazy(() => timeout(import('#client/pages/EducationStudio/components/CustomPage/Peaks/yourPassion')));
const YourIkigai = lazy(() => timeout(import('#client/pages/EducationStudio/components/CustomPage/Peaks/yourIkigai')));
const PeaksSummaryPage = lazy(() => timeout(import('#client/pages/EducationStudio/components/CustomPage/Peaks/PeaksSummaryPage')));
const ActivityCompletePage = lazy(() => timeout(import('#client/pages/EducationStudio/components/CustomPage/Waltz/ActivityCompletePage')));
const WaltzActivityPage = lazy(() => timeout(import('#client/pages/EducationStudio/components/CustomPage/Waltz/WaltzActivityPage')));
const SecondWind = lazy(() => timeout(import('#client/pages/EducationStudio/components/CustomPage/Zest/secondWind')));
const ExciteYourNervousSystem = lazy(() => timeout(import('#client/pages/EducationStudio/components/CustomPage/Zest/exciteYourNervousSystem')));
const TakeAction = lazy(() => timeout(import('#client/pages/EducationStudio/components/CustomPage/Zest/takeAction')));
const IdentifyYourWhy = lazy(() => timeout(import('#client/pages/EducationStudio/components/CustomPage/Zest/identifyYourWhy')));
const FindYourRoleModels = lazy(() => timeout(import('#client/pages/EducationStudio/components/CustomPage/Zest/findYourRoleModels')));
const HarnessYourEmotions = lazy(() => timeout(import('#client/pages/EducationStudio/components/CustomPage/Zest/harnessYourEmotions')));
const TransformYourself = lazy(() => timeout(import('#client/pages/EducationStudio/components/CustomPage/Zest/transformYourself')));
const YourPlan = lazy(() => timeout(import('#client/pages/EducationStudio/components/CustomPage/Zest/yourPlan')));
const SpideyActivityCompletePage = lazy(() => timeout(import('#client/pages/EducationStudio/components/CustomPage/Spidey/ActivityCompletePage')));
const SpideyStartActivityPage = lazy(() => timeout(import('#client/pages/EducationStudio/components/CustomPage/Spidey/StartActivityPage')));
const SpideyActivityPage = lazy(() => timeout(import('#client/pages/EducationStudio/components/CustomPage/Spidey/ActivityPage')));

const BubbleSelectionActivityPage = lazy(() => timeout(import('#client/pages/EducationStudio/components/CustomPage/BubbleSelectionActivityPage')));
const BubbleSelectionSummaryPage = lazy(() => timeout(import('#client/pages/EducationStudio/components/CustomPage/BubbleSelectionSummaryPage')));

const StartActivityPage = lazy(() => timeout(import('#client/pages/EducationStudio/components/CustomPage/StartActivityPage')));

const SingleSelectionActivityPage = lazy(() => timeout(import('#client/pages/EducationStudio/components/CustomPage/SingleSelectionActivityPage')));
const SingleSelectionSummaryPage = lazy(() => timeout(import('#client/pages/EducationStudio/components/CustomPage/SingleSelectionSummaryPage')));

const ButtergoatActivityCompletePage = lazy(() => timeout(import('#client/pages/EducationStudio/components/CustomPage/Buttergoat/ActivityCompletePage')));

// POKE activities
const ConquerYourFears = lazy(() => timeout(import('#client/pages/EducationStudio/components/CustomPage/Poke/conquerYourFears')));
const NameIt = lazy(() => timeout(import('#client/pages/EducationStudio/components/CustomPage/Poke/nameIt')));
const ReframeIt = lazy(() => timeout(import('#client/pages/EducationStudio/components/CustomPage/Poke/reframeIt')));
const TameIt = lazy(() => timeout(import('#client/pages/EducationStudio/components/CustomPage/Poke/tameIt')));
const YourPlanPoke = lazy(() => timeout(import('#client/pages/EducationStudio/components/CustomPage/Poke/yourPlan')));

const MuseUmTime = lazy(() => timeout(import('#client/pages/EducationStudio/components/CustomPage/Muse/museUmTime')));
const YourBrandMuse = lazy(() => timeout(import('#client/pages/EducationStudio/components/CustomPage/Muse/yourBrandMuse')));
const YourSocialMediaMuse = lazy(() => timeout(import('#client/pages/EducationStudio/components/CustomPage/Muse/yourSocialMediaMuse')));
const YourBusinessModelMuse = lazy(() => timeout(import('#client/pages/EducationStudio/components/CustomPage/Muse/yourBusinessModelMuse')));
const YourCultureMuse = lazy(() => timeout(import('#client/pages/EducationStudio/components/CustomPage/Muse/yourCultureMuse')));
const YourLeadershipMuse = lazy(() => timeout(import('#client/pages/EducationStudio/components/CustomPage/Muse/yourLeadershipMuse')));
const YourThoughtLeadershipMuse = lazy(() => timeout(import('#client/pages/EducationStudio/components/CustomPage/Muse/yourThoughtLeadershipMuse')));
const YourLifestyleMuse = lazy(() => timeout(import('#client/pages/EducationStudio/components/CustomPage/Muse/yourLifestyleMuse')));
const YourCreativeMuse = lazy(() => timeout(import('#client/pages/EducationStudio/components/CustomPage/Muse/yourCreativeMuse')));
const YourMoralMuse = lazy(() => timeout(import('#client/pages/EducationStudio/components/CustomPage/Muse/yourMoralMuse')));
const SummaryMuse = lazy(() => timeout(import('#client/pages/EducationStudio/components/CustomPage/Muse/summaryMuse')));

// Inside
const DiscoverYourArchetypes = lazy(() => timeout(import('#client/pages/EducationStudio/components/CustomPage/Inside/discoverYourArchetypes')));
const WhosYourVibe = lazy(() => timeout(import('#client/pages/EducationStudio/components/CustomPage/Inside/whosYourVibe')));
const SummaryPage = lazy(() => timeout(import('#client/pages/EducationStudio/components/CustomPage/Inside/summaryPage')));

export const getCustomPage = (lessonUrl, articleUrl, onClick) => {
  const customPages = {
    peaks: {
      'lets-find-your-ikigai-activity': <LetsFindYourIkigai onNext={onClick} />,
      'what-you-love-activity': <WhatYouLove onNext={onClick} />,
      'what-the-world-needs-activity': <WhatTheWorldNeeds onNext={onClick} />,
      'what-you-can-get-paid-for-activity': <WhatYouCanGetPaidFor onNext={onClick} />,
      'what-youre-good-at-activity': <WhatYoureGoodAt onNext={onClick} />,
      'your-mission-activity': <YourMission onNext={onClick} />,
      'your-vocation-activity': <YourVocation onNext={onClick} />,
      'your-profession-activity': <YourProfession onNext={onClick} />,
      'your-passion-activity': <YourPassion onNext={onClick} />,
      'your-ikigai-activity': <YourIkigai onNext={onClick} />,
      summary: <PeaksSummaryPage onPrimaryClick={onClick} />
    },
    waltz: {
      'start-activity': (
        <StartActivityPage
          onPrimaryClick={onClick}
        />
      ),
      'morning-activities': (
        <WaltzActivityPage
          time="morning"
          onPrimaryClick={onClick}
        />
      ),
      'afternoon-activities': (
        <WaltzActivityPage
          time="afternoon"
          onPrimaryClick={onClick}
        />
      ),
      'evening-activities': (
        <WaltzActivityPage
          time="evening"
          onPrimaryClick={onClick}
        />
      ),
      'activity-complete': (
        <ActivityCompletePage
          onPrimaryClick={onClick}
        />
      )
    },
    zest: {
      'second-wind-activity': <SecondWind onNext={onClick} />,
      'excite-your-nervous-system-activity': <ExciteYourNervousSystem onNext={onClick} />,
      'take-action-activity': <TakeAction onNext={onClick} />,
      'identify-your-why-activity': <IdentifyYourWhy onNext={onClick} />,
      'find-your-role-models-activity': <FindYourRoleModels onNext={onClick} />,
      'harness-your-emotions-activity': <HarnessYourEmotions onNext={onClick} />,
      'transform-yourself-activity': <TransformYourself onNext={onClick} />,
      'your-plan-activity': <YourPlan onNext={onClick} />
    },
    spidey: {
      'start-activity': (
        <SpideyStartActivityPage
          onPrimaryClick={onClick}
        />
      ),
      'hsp-activities': (
        <SpideyActivityPage
          onPrimaryClick={onClick}
        />
      ),
      'activity-complete': (
        <SpideyActivityCompletePage
          onPrimaryClick={onClick}
        />
      )
    },
    poke: {
      'conquer-your-fears': <ConquerYourFears onNext={onClick} />,
      'your-plan-activity': <YourPlanPoke onNext={onClick} />,
      'step-1-name-it': <NameIt onNext={onClick} />,
      'step-2-reframe-it': <ReframeIt onNext={onClick} />,
      'step-3-tame-it': <TameIt onNext={onClick} />
    },
    muse: {
      'muse-um-time-activity': <MuseUmTime onNext={onClick} />,
      'your-brand-muse-activity': <YourBrandMuse onNext={onClick} />,
      'your-social-media-muse-activity': <YourSocialMediaMuse onNext={onClick} />,
      'your-business-model-muse-activity': <YourBusinessModelMuse onNext={onClick} />,
      'your-culture-muse-activity': <YourCultureMuse onNext={onClick} />,
      'your-leadership-muse-activity': <YourLeadershipMuse onNext={onClick} />,
      'your-thought-leadership-muse-activity': <YourThoughtLeadershipMuse onNext={onClick} />,
      'your-lifestyle-muse-activity': <YourLifestyleMuse onNext={onClick} />,
      'your-creative-muse-activity': <YourCreativeMuse onNext={onClick} />,
      'your-moral-muse-activity': <YourMoralMuse onNext={onClick} />,
      summary: <SummaryMuse onNext={onClick} />
    },
    buttergoat: {
      'activity-complete': (
        <ButtergoatActivityCompletePage
          onPrimaryClick={onClick}
        />
      )
    },
    inside: {
      'discover-your-archetypes-activity': <DiscoverYourArchetypes onNext={onClick} />,
      'whos-your-vibe-activity': <WhosYourVibe onNext={onClick} />,
      'summary-activity': <SummaryPage onNext={onClick} />
    }
  };

  if (articleUrl === 'preview') {
    return <IntroPage onPrimaryClick={onClick} />;
  }

  if (articleUrl === 'start-activity') {
    return <StartActivityPage onPrimaryClick={onClick} />;
  }

  if (articleUrl.startsWith('bubble-selection-activity')) {
    return <BubbleSelectionActivityPage onPrimaryClick={onClick} />;
  }

  if (articleUrl.startsWith('bubble-selection-summary')) {
    return <BubbleSelectionSummaryPage onPrimaryClick={onClick} />;
  }

  if (articleUrl.startsWith('single-selection-activity')) {
    return <SingleSelectionActivityPage onPrimaryClick={onClick} />;
  }

  if (articleUrl.startsWith('single-selection-summary')) {
    return <SingleSelectionSummaryPage onPrimaryClick={onClick} />;
  }

  if (!customPages[lessonUrl] || !customPages[lessonUrl][articleUrl]) {
    return <GenericPage onPrimaryClick={onClick} />;
  }

  return customPages[lessonUrl][articleUrl];
};
